import e from"./header/index.js";import i from"./sideNav/index.js";import r from"./sidePanel/index.js";var d={sideNav:i,sidePanel:r,header:e};export{d as layoutDefaultTheme};
